import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  usePostItemOrderMutation,
  useTotalItemMutation,
} from "../../../../store/api/itemapi";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ExportCSV from '../../../../Core/Export/ExportCSV'
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";
import noImage from "../../../../assets/no-image.png";

const MainContent = () => {
  const navigate = useNavigate();
  const { screenHeight, screenScaling } = useScreenHeight();
  const [pageSize, setPageSize] = useState(0);
  
  useEffect(() => {
    // console.log(
	// 		"DEBUG → screenHeight:",
	// 		screenHeight,
	// 		"screenScaling:",
	// 		screenScaling
	// 	);
	  if (screenHeight && screenScaling) {
			let count;

			// Small screens
			if (screenHeight < 600) {
				count = 5;
			}
			else if (screenHeight < 622 && screenScaling === 1.5) {
				count = 10
			}
			else if (screenHeight < 767 && screenScaling === 1.25) {
				count = 12;
			}
			else if (screenHeight < 981 && screenScaling === 1) {
				count = 16;
			}
			// Fallback for 600–979 range (you had no rule for this!)
			else {
				count = 12; // or define your own logic here
			}
			setPageSize(count);
		}
	}, [screenHeight, screenScaling]);
  
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setCountItemData] = useState(0);
  const [itemData, setItemData] = useState({
    item_list: [],
    total_no_of_records: 0,
  });
  const [itemDataApi] = usePostItemOrderMutation();
  const [totalitemCountApi] = useTotalItemMutation();
  const [showColumnConfig, setShowColumnConfig] = useState(false);
  const [showExportPopup, setShowExportPopup] = useState(false);

//states used for deleting the record
  const [deleteDoc] = useDeleteDocMutation();
  const [delPopupVisible, setDelPopupVisible] = useState(false);
  const [delSelectedId, setDelSelectedId] = useState(null);
  const [delmessage, setDelmessage] = useState();
  const [alreadySubmitData, setAlreadySubmitData] = useState(false);
  const [delDone, setDelDone] = useState(false);

  const filtersConfig = [
    { name: "siNo", label: "S. No", width: "3.8%",type:'number' },
    { name: "item_name", label: "Item Name", width: "17.2%",type:'text' },
    { name: "item_group", label: "Item Group", width: "17.2%",type:'text' },
    { name: "name", label: "Id", width: "17.2%",type:'text' },
    { name: "creation", label: "Date", type: "date", width: "17.2%" },
    { name: "disabled", label: "Status", width: "17.2%", type: "select", options: [
        { value: "0", label: "Enabled" },
        { value: "1", label: "Disabled" },
      ],
    },
  ];

  const handleFilterChange = (newFilters) => {
    setCurrentPage(1);
    setFilters(newFilters);
  };
  const handleView = (id) => {
    try {
      navigate(`/master/item/view-item/`, { state: { ItemId: id } });
    } catch (err) {
      console.error("Edit failed:", err);
    }
  };
  const handleEdit = async (id) => {
    try {
      navigate(`/master/item/edit-item/`, { state: { ItemId: id } });
    } catch (err) {
      console.error("Edit failed:", err);
    }
  };
 
const handleDelete = (id) => {
	setDelSelectedId(id);
	setDelPopupVisible(true);
	setAlreadySubmitData(false);
	setDelmessage("Are you sure you want to Delete this Item?");
};

const delHandleCancel = () => {
	setDelPopupVisible(false);
	setDelSelectedId(null);
};

const delHandleConfirm = async () => {
	try {
		await deleteDoc({
			doctype: "Item",
			name: delSelectedId,
		}).unwrap();
		setDelmessage(`Item ${delSelectedId} deleted successfully!`);
		setDelDone(true);
		setTimeout(() => {
			setDelPopupVisible(false);
			setDelSelectedId(null);
			setDelDone(false);
			getCountData();
			getData();
		}, 1000);
	} catch (err) {
		console.error("Deletion Failed:", err);

		let errorMessage = "Failed to delete the Item!";

		//If the server is sending the error message , we will extract it.
		if (err?.data?._server_messages) {
			try {
				const messageArr = JSON.parse(err.data._server_messages);
				if (messageArr && messageArr.length > 0) {
					//parse inner json object
					const messageObj = JSON.parse(messageArr[0]);
					if (messageObj?.message) {
						//extract the exact message we want
						const fullMessage = messageObj.message;
						//remove html in the message
						errorMessage = fullMessage.replace(/<[^>]+>/g, "");
					}
				}
			} catch (parseError) {
				console.error("Error parsing server messages:", parseError);
			}
		}
		setDelPopupVisible(true);
		setDelmessage(errorMessage);
		setAlreadySubmitData(true);
	} finally {
		// setTimeout(() => {
		//     setDelPopupVisible(false);
		//     setDelSelectedId(null);
		// }, 2000);
	}
};

  const [columnsConfig, setColumnsConfig] = useState(() => [
		{
			header: "S. No.",
			name: "S. No.",
			accessor: "siNo",
			width: "4.5%",
			sortable: false,
			cellRenderer: (row) => row.siNo,
			visible: true,
		},
		{
			header: "Item Image",
			name: "Item Image",
			accessor: "image",
			width: "10%",
			visible: true,
			cellRenderer: (row) =>
				row.image ? (
					<img
						src={`${process.env.REACT_APP_API_URL}/${row.image}`}
						style={{ width: "50px", height: "30px", objectFit: "cover" }}
						alt="Item"
					/>
				) : (
					<img
						src={noImage}
						style={{ width: "50px", height: "30px", objectFit: "cover" }}
						alt="Item"
					/>
				),
		},
		{
			header: "Item Name",
			name: "Item Name",
			accessor: "item_name",
			width: "17.2%",
			sortable: true,
			visible: true,
		},
		{
			header: "Item Group",
			name: "Item Group",
			accessor: "item_group",
			width: "17.2%",
			sortable: true,
			visible: false,
		},
		{
			header: "Id",
			name: "ID",
			accessor: "name",
			width: "17.2%",
			sortable: true,
			visible: false,
			// Custom sorting for numbers
			sortFn: (a, b) => parseInt(a.no_of_lines) - parseInt(b.no_of_lines),
		},
		{
			header: "Status",
			name: "Status",
			accessor: "disabled",
			width: "17.2%",
			sortable: true,
			visible: true,
			cellRenderer: (row) => {
				const isDisabled = row.disabled === 1;
				const label = isDisabled ? "Disabled" : "Enabled";
				const color = isDisabled ? "#D97706" : "#6366F1";

				return <span style={{ color }}>{label}</span>;
			},
		},
		{
			header: "Date",
			name: "Date",
			accessor: "creation",
			width: "17.2%",
			sortable: true,
			visible: true,
			// Custom sorting for dates
			sortFn: (a, b) => new Date(a.date) - new Date(b.date),
			cellRenderer: (row) => {
				return row.creation.split(" ")[0];
			},
		},
		{
			header: "Action",
			name: "Action",
			accessor: "action",
			width: "10.2%",
			sortable: false,
			visible: true,
			cellRenderer: (row) => (
				<ActionButtonDropdown
					id={row.name}
					onView={() => handleView(row.name)}
					onEdit={() => handleEdit(row.name)}
					onDelete={() => handleDelete(row.name)}
				/>
			),
		},
	]);

  // Handle column configuration changes
  const handleSaveColumns = (selectedKeys, allFields) => {
    const updatedColumns = columnsConfig.map(column => {
      return {
        ...column,
        visible: selectedKeys.includes(column.accessor)
      };
    });
    setColumnsConfig(updatedColumns);
  }
  const visibleColumns = useMemo(() =>
    columnsConfig.filter(col => col.visible === true),
    [columnsConfig]
  );

  const defaultSelectedColumns = useMemo(() =>
    columnsConfig
      .filter(col => col.visible === true)
      .map(col => ({
        fieldname: col.accessor,
        label: col.name
      }))
      .filter(col => col.fieldname),
    [columnsConfig]
  );
  const activeFilterCount = useMemo(() => {
    return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
  }, [filters]);

  const actionButtons = [
    {
      className: "createbtn border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "IoFilterSharp",
      iconSize: 12,
      children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
      onClick: () => {
        setShowFilters(prev => !prev);
        setShowColumnConfig(false);
      }
    },
    {
      className: "createbtn border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "MdOutlineRemoveRedEye",
      iconSize: 12,
      children: "Show more",
      onClick: () => {
        setShowColumnConfig(prev => !prev);
        setShowFilters(false);
      }
    },
    {
      className: "createbtn border-0 d-flex",
      style: { gap: "2px", height: "28px" },
      iconName: "RiFileExcel2Fill",
      iconSize: 12,
      children: "Export Excel",
      onClick: () => setShowExportPopup(true),
    },
    {
      className: "custom-btn-00989 d-flex",
      to: "/master/item/create-item",
      iconName: "FiPlus",
      style: { gap: "2px", height: "28px" },
      children: "Add Item",
    },

  ];

  const getData = async () => {
    setLoading(true);

    try {
      // STEP 1: Clean filters
      const filteredSearchInput = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value !== '' && value !== undefined && value !== null) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const siNoFilter = filteredSearchInput.siNo;
      const isSiNoFilterActive = siNoFilter !== undefined && siNoFilter !== "";

      // STEP 2: Remove siNo from API filter
      const frappeFilters = Object.entries(filteredSearchInput)
        .filter(([key]) => key !== "siNo")
        .map(([key, value]) => {
          if (key === "creation") {
            return ["Item", key, "=", value];
          }
          return ["Item", key, "like", `%${value}%`];
        });

      // STEP 3: If filtering by siNo, jump to that page
      const targetPage = isSiNoFilterActive
        ? Math.ceil(parseInt(siNoFilter, 10) / pageSize)
        : currentPage;

      const payload = {
        start: pageSize * (targetPage - 1),
        limit: pageSize,
        filters: frappeFilters,
        fields: [
          "item_name",
          "item_group",
          "disabled",
          "item_code",
          "naming_series",
          "name",
          "creation",
          "image"
        ],
      };

      const response = await itemDataApi(payload);
      const rawData = response.data.data;

      // STEP 4: Assign global serial numbers
      const numberedData = rawData.map((item, index) => ({
        ...item,
        siNo: index + 1 + pageSize * (targetPage - 1),
      }));

      // STEP 5: If siNo is used, filter client-side
      const finalData = isSiNoFilterActive
        ? numberedData.filter((item) => item.siNo === parseInt(siNoFilter, 10))
        : numberedData;

        setItemData(finalData);

      // Optional: update currentPage to reflect jump
      if (isSiNoFilterActive) setCurrentPage(targetPage);
    } catch (error) {
      console.error("Error fetching item:", error);
    } finally {
      setLoading(false);
    }
  };


  const getCountData = async () => {
    setLoading(true);
    try {
      const response = await totalitemCountApi();
      if (response?.data) {
        setCountItemData(response?.data);
        //   console.log('count:', response?.data);
      }
    } catch (error) {
      console.error("Error fetching item count:", error);
    } finally {
      setLoading(false);
    }
  };
	useEffect(() => {
		
		if( pageSize !== 0)
		{
			getData();
			getCountData();
		}
  }, [currentPage, filters, pageSize]);

  const [showFilters, setShowFilters] = useState(false)
  const accessors = columnsConfig
		.filter(
			(column) => column.accessor !== "siNo" && column.accessor !== "action"
		)
		.map((column) => column.accessor);

  return (
		<div
			className="container-fluid d-flex flex-column "
			style={{ flexGrow: "1" }}
		>
			<Tabs />
			<ListLayout
				breadcrumbItems={[
					{ label: "Item" },
					{
						label: "Item List",
						style: {
							borderBottom: "0px solid",
							textWrap: "nowrap",
							gap: "5px",
							color: "#270B79",
							fontSize: "",
						},
					},
				]}
				actionButtons={actionButtons}
			>
				{showFilters && (
					<ListFilters
						filtersConfig={filtersConfig}
						onFilterChange={handleFilterChange}
						currentFilters={filters}
						setShowFilters={setShowFilters}
					/>
				)}

				{showColumnConfig && (
					<ConfigureColumnsNew
						show={showColumnConfig}
						onClose={() => setShowColumnConfig(false)}
						onSave={handleSaveColumns}
						docType="Item"
						defaultSelected={defaultSelectedColumns}
						fieldsData={columnsConfig.map((col) => ({
							fieldname: col.accessor,
							label: col.name,
						}))}
						disabledFields={[
							"siNo",
							"disabled",
							"action",
							"creation",
							"item_name",
						]}
					/>
				)}

				<Table columns={visibleColumns} data={itemData} loading={loading} />

				<Pagination
					setCurrentPage={setCurrentPage}
					pageSize={pageSize}
					totalRecords={totalRecords.message}
					currentPage={currentPage}
					className="mt-2 pb-3"
				/>
				{delPopupVisible && (
					<DelConfirmPopup
						alredysubmitdata={alreadySubmitData}
						delSelectedId={delSelectedId}
						visible={delPopupVisible}
						message={delmessage}
						onConfirm={delHandleConfirm}
						onCancel={delHandleCancel}
						delDone={delDone}
					/>
				)}

				{showExportPopup && (
					<ExportCSV
						doctype="Item"
						fieldsData={accessors}
						onClose={() => setShowExportPopup(false)}
					/>
				)}
			</ListLayout>
		</div>
	);
};

export default MainContent;
